import React, { FC } from 'react';

import { ButtonLabel, ButtonVariant, EntityActions } from 'common/enums';
import { Button, InputWithSearchIcon } from 'common/components';

import { Mode } from 'modules/data-editor/enums/mode.enum';

import './Header.scss';

type HeaderProps = {
    dataEditorMode: string;
    isButtonDisabled: boolean;
    searchVal: string;
    isRightSectionHidden: boolean;
    isDataEditorUploadDisabled: boolean;
    isDataEditorPreviewDisabled: boolean;
    isMapToMasterDataDisabled: boolean;
    onPrimaryAction: (action: EntityActions) => () => void;
    onSearchChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSearch: () => void;
    onSecondaryAction: (action: EntityActions) => () => void;
};

const Header: FC<HeaderProps> = ({
    dataEditorMode,
    onPrimaryAction,
    isButtonDisabled,
    searchVal,
    isRightSectionHidden,
    isDataEditorUploadDisabled,
    isDataEditorPreviewDisabled,
    isMapToMasterDataDisabled,
    onSearchChangeHandler,
    onSecondaryAction
}: HeaderProps) => {
    return (
        <div
            className={`data-editor-header-container ${
                isRightSectionHidden && 'right-section-hidden'
            }`}>
            <div
                className={`data-editor-header ${
                    dataEditorMode === Mode.DataLoaded ? '' : 'header-default'
                }`}>
                {dataEditorMode === Mode.DataLoaded ? 'Data Editor - Preview Mode' : 'Data Editor'}
            </div>
            {!isRightSectionHidden && (
                <div className="header-right">
                    {dataEditorMode === Mode.DataLoaded && (
                        <InputWithSearchIcon
                            className="search-input"
                            formClassName="search-input-container"
                            placeholder="Search"
                            value={searchVal}
                            onChange={onSearchChangeHandler}
                            hideClearButton={false}
                        />
                    )}
                    {dataEditorMode === Mode.DataLoaded && (
                        <Button
                            disabled={isDataEditorPreviewDisabled}
                            onClick={onSecondaryAction(EntityActions.ClearPreview)}
                            className="data-editor-header-button transparent-bg"
                            variant={ButtonVariant.Secondary}>
                            {ButtonLabel.ClearPreview}
                        </Button>
                    )}
                    <Button
                        onClick={onPrimaryAction(
                            dataEditorMode === Mode.DataLoaded
                                ? EntityActions.LoadToMaster
                                : EntityActions.Upload
                        )}
                        className="data-editor-header-button"
                        disabled={
                            dataEditorMode === Mode.DataLoaded
                                ? isDataEditorUploadDisabled || isButtonDisabled
                                : isMapToMasterDataDisabled || isButtonDisabled
                        }>
                        {dataEditorMode === Mode.DataLoaded ? 'Load to Master data' : 'Upload data'}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default Header;
